import { useApi } from "../../../lib/api"
import { useMemo } from "react"
import { useParams } from "react-router-dom"

export function usePlaylogs(ClientUuid: string | undefined, type: string | undefined, filters: object) {
  const { id } = useParams()
  let serviceType: string
  if (type && type.toLowerCase() === "video") {
    serviceType = "videomedia"
  } else {
    serviceType = "audiomedia"
  }
  const queryString = Object.entries(filters)
    .map((query) => {
      //Join all query keys values with ','
      const values = query[1]
      //add these values to name of the query
      return query[0] + "=" + values
    })
    .join("&") //join fi

  const [response, error, loading, retry] = useApi(`/logging/devices/` + id + `/playlogs/` + serviceType + `?${queryString}`)
  const data = useMemo(() => response?.data?.array ?? [], [response?.data?.array])
  return useMemo(() => [data, error, loading, retry], [data, error, loading, retry])
}
export interface Playlogs {
  endTime?: string
  filename?: string
  id?: number
  media?: string
  mediaName?: string
  mediaType?: string
  startTime?: string
}
